<template>
  <BreadCrumb class="hidden sm:block" />
  <AboutHomePage :entry="entry" />
</template>
<script>
import gql from 'graphql-tag';
import { stripLocale } from '@/utils/i18n';
import AboutHomePage, { AboutHomePageFragment } from '@/components/about/AboutHomePage';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const AboutIndexQuery = gql`
  query AboutIndexQuery($site: String!, $uri: String!) {
    entry(section: "about", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...AboutHomePageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${SeomaticFragment}
  ${AboutHomePageFragment}
`;

export default defineNuxtComponent({
  name: 'AboutIndex',

  components: { AboutHomePage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    try {
      const { entry, seomatic } = await $craftRequest(AboutIndexQuery, variables);

      return { entry, seomatic };
    } catch (error) {
      console.log('test', AboutIndexQuery);
    }
  },

  data() {
    return { entryPage: null };
  },

  created() {
    this.entryPage = useEntryPage(this.entry, this.seomatic);
  },
});
</script>
